import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { Switch, Route } from 'react-router-dom';
import CloseIcon from 'components/CloseIcon';
import ProfileTabView from './ProfileTabView';
import ProfileLoyaltyInfo from './ProfileLoyaltyInfo';
import ProfileRewardsList from './ProfileRewardsList';
import './ProfilePage.css';

class ProfilePage extends Component {
  render() {
    return (
      <div>
        <Grid className="main-container profile-container">
          <Row className="profile-window">
            <div className="col left-panel">
              <ProfileLoyaltyInfo />
            </div>
            <div className="col right-panel">
              <ProfileTabView />
              <div className="panel-content">
                <Switch>
                  <Route path="/rewards" exact component={ProfileRewardsList} />
                  {/*
                  <Route
                    path="/profile"
                    exact
                    component={ProfileDetails}
                  />
                  */}
                </Switch>
              </div>
            </div>
          </Row>
          <CloseIcon url="/" />
        </Grid>
      </div>
    );
  }
}

export default ProfilePage;



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/index.js